import { ColorModeContext, useMode } from "./theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Routes, Route } from "react-router-dom";
import StudentLogin from "./components/auth/StudentLogin";
import StudentRegister from "./components/auth/StudentRegister";
import TeacherLogin from "./components/auth/TeacherLogin";
import TeacherRegister from "./components/auth/TeacherRegister";
import AdminLogin from "./components/auth/AdminLogin";
import AdminRegister from "./components/auth/AdminRegister";
import Home from "./pages/home";
import ArticleDetails from "./pages/articleDetails";
import TermsConditions from "./pages/termsConditions";
import PrivacyPolicy from "./pages/privacyPolicy";
import Dashboard from "./pages/dashboard";
import Departments from "./pages/sidebar/data/departments";
import Sections from "./pages/sidebar/data/sections";
import Teachers from "./pages/sidebar/data/teachers";
import Students from "./pages/sidebar/data/students";
import Admins from "./pages/sidebar/data/admins";
import Dictionary from "./pages/sidebar/data/dictionary";
import Contacts from "./pages/sidebar/pages/contacts";
import Complaints from "./pages/sidebar/pages/complaints";
import Calendar from "./pages/sidebar/pages/calendar";
import FAQ from "./pages/sidebar/pages/faq";
import Bar from "./pages/sidebar/charts/barChart";
import Line from "./pages/sidebar/charts/lineChart";
import Pie from "./pages/sidebar/charts/pieChart";
import Geography from "./pages/sidebar/charts/geographyChart";

const App = () => {
  const [theme, colorMode] = useMode();

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/article-details" element={<ArticleDetails />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/login" element={<StudentLogin />} />
          <Route path="/register" element={<StudentRegister />} />
          <Route path="/teacherLogin" element={<TeacherLogin />} />
          <Route path="/teacherRegister" element={<TeacherRegister />} />
          <Route path="/adminLogin" element={<AdminLogin />} />
          <Route path="/adminRegister" element={<AdminRegister />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/departments" element={<Departments />} />
          <Route path="/sections" element={<Sections />} />
          <Route path="/teachers" element={<Teachers />} />
          <Route path="/students" element={<Students />} />
          <Route path="/admins" element={<Admins />} />
          <Route path="/dictionary" element={<Dictionary />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/complaints" element={<Complaints />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/bar" element={<Bar />} />
          <Route path="/line" element={<Line />} />
          <Route path="/pie" element={<Pie />} />
          <Route path="/geography" element={<Geography />} />
        </Routes>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};

export default App;
